export const checkLoginTime = () => {
  const loginTime = localStorage.getItem("login_time");

  if (!loginTime) {
    return false;
  }

  const currentTime = new Date().getTime();
  const twoMinutesInMilliseconds = 24 * 60 * 60 * 1000;
  // 2 * 60 * 1000; // 2 minutes for testing

  if (currentTime - loginTime > twoMinutesInMilliseconds) {
    clearAllLocalStorage();
    return false;
  }

  return true;
};

export const clearAllLocalStorage = () => {
  // Attempt to clear tenant domain's localStorage first
  const tenantName = localStorage.getItem("tenant_name");

  const clearTenantStorage = new Promise((resolve) => {
    if (tenantName) {
      const tenantDomain = `${tenantName}.localhost:3000`;
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = `http://${tenantDomain}`;

      iframe.onload = () => {
        try {
          iframe.contentWindow.localStorage.clear();
          console.log(`Cleared localStorage for tenant domain: ${tenantDomain}`);
        } catch (error) {
          console.error(`Failed to clear localStorage for tenant domain: ${tenantDomain}`, error);
        } finally {
          document.body.removeChild(iframe); // Clean up iframe
          resolve(); // Signal tenant storage clearing is complete
        }
      };

      document.body.appendChild(iframe);
    } else {
      resolve(); // No tenant domain, resolve immediately
    }
  });

  // Clear `localhost:3000` localStorage after tenant domain
  clearTenantStorage.then(() => {
    console.log("Clearing localStorage for localhost:3000");
    localStorage.clear();
  });
};


